/* eslint-disable @typescript-eslint/explicit-module-boundary-types */

import {
  h, createApp, ref, nextTick,
} from 'vue'
import type { App } from 'vue'
import ViewerComponent from './ViewerComponent.vue'

type CmpOptions = InstanceType<typeof ViewerComponent>['$props'] & {
  onHidden?: () => void
}

const defaultViewProps: CmpOptions = {
  images: [],
  options: {
    initialViewIndex: 0,
  },
}

export const CreateViewer = (options = defaultViewProps) => {
  let container: HTMLElement | null = document.createElement('div')
  document.body.appendChild(container)
  let app: App<Element> | null = null

  const propsRef = ref(options)
  const show = ref(false)
  app = createApp({
    setup() {
      return () => h(
        <ViewerComponent
          show={show.value}
          {...propsRef.value}
        />,
      )
    },
  })
  app.mount(container)
  return {
    destroy() {
      if (!app || !container) {
        return
      }
      app.unmount()
      document.body.removeChild(container)
      app = null
      container = null
    },
    view(images: string[], ops: any = {}, toolbarVariant: 'minimal'|'default' = 'minimal') {
      if (show.value === true) {
        show.value = false
      }
      return new Promise<void>(resolve => {
        propsRef.value = {
          ...propsRef.value,
          options: ops,
          toolbarVariant,
          images,
          onHidden: () => {
            resolve()
            propsRef.value = options
            show.value = false
          },
        }
        nextTick(() => {
          show.value = true
        })
      })
    },
  }
}

let viewerCmp: any | undefined

export const getViewer = (initOptions?: CmpOptions) => {
  if (!viewerCmp) {
    viewerCmp = CreateViewer(initOptions)
  }
  return viewerCmp
}

export const viewImgs = (images: string[], overrideProps = {}, variant?: 'minimal'|'default') => {
  const viewer = getViewer()
  return viewer.view(images, overrideProps, variant)
}
